import React, { useEffect } from 'react';
import { FileText, Download, Scale, Image, BookOpen, Shield } from 'lucide-react';
import '../styles/global.css';
import Carousel from '../components/Carousel';
function Chiffres () {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const brochures = [
    {
      id: 1,
      title: "الحملة الوطنية لمناهضة العنف الرقمي ضد النساء والفتيات: لماذا، أين وكيف؟ ",
       fileName: "الحملة الوطنية لمناهضة العنف الرقمي ضد النساء والفتيات لماذا، أين وكيف.pdf",
      pages: "4 صفحة",
      size: "1 MB",
      icon: Shield,
      color: "#ff6b35"
    },
    {
      id: 2,
      title: "مختصر مفيد: العنف الذي تيسره التكنولوجيا",
 fileName: "مختصر مفيد العنف الذي تيسره التكنولوجيا.pdf",
      pages: "12 صفحة",
      size: "21 MB",
      icon: FileText,
      color: "#ff8555"
    },
    {
      id: 3,
      title: "العنف الرقمي ضد النساء بالفتيات: جائحة صامة تهدد المجتمع",
 fileName: "العنف الرقمي ضد النساء بالفتيات جائحة صامة تهدد المجتمع.pdf",
      pages: "2 صفحة",
      size: "4 MB",
      icon: BookOpen,
      color: "#ff6b35"
    }
  ];

  const legalTexts = [
    {
      id: 1,
      title: "القانون رقم 103.13",
      subtitle: "محاربة العنف ضد النساء",
      description: "النص الكامل للقانون المتعلق بمحاربة العنف ضد النساء، بما في ذلك الأحكام الخاصة بالعنف الرقمي والتحرش الإلكتروني",
      year: "2018",
      articles: "20 مادة"
    },
    {
      id: 2,
      title: "القانون رقم 05-20",
      subtitle: "الأمن السيبراني",
      description: "الإطار القانوني للأمن السيبراني وحماية المعطيات الشخصية في الفضاء الرقمي",
      year: "2020",
      articles: "15 مادة"
    },
    {
      id: 3,
      title: "القانون رقم 09-08",
      subtitle: "حماية الأشخاص الذاتيين",
      description: "قانون حماية الأشخاص الذاتيين تجاه معالجة المعطيات ذات الطابع الشخصي",
      year: "2009",
      articles: "58 مادة"
    },
    {
      id: 4,
      title: "مشروع قانون الجرائم الإلكترونية",
      subtitle: "الإطار التشريعي الجديد",
      description: "مشروع القانون الجديد المتعلق بمكافحة الجرائم الإلكترونية والعنف الرقمي",
      year: "2024",
      articles: "في طور المصادقة"
    }
  ];

  const photoGallery = [
    {
      id: 1,
      title: "ورشة توعوية حول العنف الرقمي - الرباط",
      image: "/images/2.jpeg"
    },
    {
      id: 2,
      title: "لقاء مع ضحايا العنف الرقمي",
      image: "/images/3.jpeg"
    },
    {
      id: 3,
      title: "حملة التوعية في الجامعات المغربية",
      image: "/images/4.jpeg"
    },
    {
      id: 4,
      title: "ندوة حول القوانين المغربية ضد العنف الرقمي",
      image: "/images/5.jpeg"
    },
    {
      id: 5,
      title: "تدريب الشباب على الحماية الرقمية",
      image: "/images/6.jpeg"
    },
    {
      id: 6,
      title: "مسيرة ضد العنف الرقمي - الدار البيضاء",
      image: "/images/7.jpeg"
    },
    {
      id: 7,
      title: "شهادات الناجيات من العنف الرقمي",
      image: "/images/8.jpeg"
    },
    {
      id: 8,
      title: "ورشة مع الإعلاميين حول تغطية قضايا العنف",
      image: "/images/9.jpeg"
    },
    {
      id: 9,
      title: "برنامج دعم نفسي للضحايا",
      image: "/images/10.jpeg"
    }
  ];

  // Fonction pour télécharger le PDF
  const handleDownload = (fileName, title) => {
    const link = document.createElement('a');
    link.href = `/documents/${fileName}`;
    link.download = fileName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="digital-violence-page" style={{ backgroundColor: '#1a1a1a', minHeight: '100vh' }}>


    {/* Hero Section */}
    <div style={{
      padding: '80px 0 40px',
      textAlign: 'center',
      backgroundImage: 'url(/images/cover.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      width: '100%',
      marginLeft: 'calc(-50vw + 50%)',
      minHeight: '400px'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 1
      }}></div>
      <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>

      <style jsx>{`
        @media (max-width: 768px) {
          .caravan-page > div:nth-child(1) {
            padding: 60px 0 30px !important;
            min-height: 300px !important;
          }
          .caravan-page h1 {
            font-size: 2.5rem !important;
          }
          .caravan-page h3 {
            font-size: 1.5rem !important;
          }
        }
      `}</style>

      <h1 style={{
        fontSize: '3.5rem',
        marginBottom: '20px',
        background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }}>
      العنف الرقمي: أرقام ووثائق
      </h1>

      </div>
    </div>




      {/* Brochures Section */}
      <div className="container" style={{ padding: '60px 0' }}>
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2.5rem',
            color: '#ffffff',
            marginBottom: '15px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '15px'
          }}>
            <BookOpen size={40} color="#ff6b35" />
          مراجع ومطويات
          </h2>
          <p style={{
            fontSize: '1.2rem',
            color: '#b0b0b0',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            مطبوعات توعوية شاملة قابلة للتحميل والطباعة
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '30px',
          marginBottom: '40px'
        }}>
          {brochures.map((brochure, index) => {
            const Icon = brochure.icon;
            return (
              <div key={brochure.id} style={{
                background: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
                borderRadius: '20px',
                padding: '35px',
                border: '1px solid rgba(255, 107, 53, 0.2)',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                position: 'relative',
                overflow: 'hidden'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.borderColor = brochure.color;
                e.currentTarget.style.boxShadow = `0 10px 30px rgba(255, 107, 53, 0.3)`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = 'rgba(255, 107, 53, 0.2)';
                e.currentTarget.style.boxShadow = 'none';
              }}>
                <div style={{
                  position: 'absolute',
                  top: '-50px',
                  left: '-50px',
                  width: '150px',
                  height: '150px',
                  background: `radial-gradient(circle, ${brochure.color}20 0%, transparent 70%)`,
                  borderRadius: '50%'
                }}></div>

                <div style={{
                  background: `${brochure.color}15`,
                  width: '70px',
                  height: '70px',
                  borderRadius: '15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px',
                  position: 'relative'
                }}>
                  <Icon size={35} color={brochure.color} strokeWidth={1.5} />
                </div>

                <h3 style={{
                  fontSize: '1.5rem',
                  color: '#ffffff',
                  marginBottom: '15px',
                  fontWeight: '600'
                }}>
                  {brochure.title}
                </h3>

                <p style={{
                  fontSize: '1rem',
                  color: '#b0b0b0',
                  lineHeight: '1.7',
                  marginBottom: '20px'
                }}>
                  {brochure.description}
                </p>

                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '20px',
                  padding: '15px 0',
                  borderTop: '1px solid rgba(255, 107, 53, 0.2)',
                  borderBottom: '1px solid rgba(255, 107, 53, 0.2)'
                }}>
                  <span style={{ color: '#e0e0e0', fontSize: '0.95rem' }}>
                    📄 {brochure.pages}
                  </span>
                  <span style={{ color: '#e0e0e0', fontSize: '0.95rem' }}>
                    💾 {brochure.size}
                  </span>
                </div>

                <button
       key={brochure.id}
       className="cta-button"
       onClick={() => handleDownload(brochure.fileName, brochure.title)}
       style={{
         width: '100%',
         display: 'flex',
         alignItems: 'center',
         justifyContent: 'center',
         gap: '10px',
         padding: '15px'
       }}
     >
       <Download size={20} />
       تحميل الكتيب
     </button>
              </div>
            );
          })}
        </div>
      </div>



      <div className="section-separator2"></div>

      {/* International and National Legal References Section */}
      <div className="container" style={{ padding: '60px 0' }}>
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2.5rem',
            color: '#ffffff',
            marginBottom: '15px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '15px'
          }}>
            <Scale size={40} color="#ff6b35" />
          وثائق مرجعية: دستورية، تشريعية ودولية
          </h2>
          <p style={{
            fontSize: '1.2rem',
            color: '#b0b0b0',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
الدستور، القانون المغربي، اتفاقيات وتقارير أممية واقليمية  تهم مناهضة العنف والعنف الذي تيسره التكنولوجيا ضد النساء والفتيات          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '25px',
          marginBottom: '40px'
        }}>
          {[
            {
              title: "دستور المملكة المغربية 2011",
              desc: "الإطار الدستوري الذي يكرس المساواة بين الجنسين ويحظر التمييز",
              link: "https://www.sgg.gov.ma/Portals/1/lois/constitution_2011_Ar.pdf"
            },
            {
              title: "القانون 103.13 المتعلق بمحاربة العنف ضد النساء",
              year: "دخل حيز التنفيذ سنة 2018",
              desc: "القانون الشامل لمحاربة جميع أشكال العنف ضد المرأة",
              link: "https://social.gov.ma/wp-content/uploads/2020/08/fin-قانون-الوزارة.pdf"
            },
            {
              title: "اتفاقية القضاء على جميع أشكال التمييز ضد المرأة (سيداو)",
              year: "اعتمدت من طرف الأمم المتحدة سنة 1979",
              desc: "وثيقة الحقوق الدولية للنساء",
              link: "https://legal.un.org/avl/pdf/ha/cedaw/cedaw_a.pdf"
            },
            {
              title: "اتفاقية مجلس أوروبا للوقاية من العنف ضد النساء",
              year: "اتفاقية اسطنبول - 11 ماي 2011",
              desc: "معاهدة شاملة لمنع ومكافحة العنف ضد المرأة والعنف المنزلي",
              link: "https://rm.coe.int/168046246c"
            },
            {
              title: "تقرير المقررة الخاصة بشأن العنف على الإنترنت",
              year: "A/HRC/38/47 - سنة 2018",
              desc: "العنف ضد النساء والفتيات على شبكة الإنترنت من منظور حقوق الإنسان",
              link: "https://documents.un.org/doc/undoc/gen/g18/184/58/pdf/g1818458.pdf"
            },
            {
              title: "تقرير الأمين العام للأمم المتحدة",
              year: "8 أكتوبر 2024",
              desc: "تقرير الأمين العام – الدورة التاسعة والسبعون للجمعية العامة: تكثيف الجهود من أجل القضاء على جميع أشكال العنف ضد النساء والفتيات: العنف ضد النساء والفتيات الذي تيسره التكنولوجيا",
              noLink: true
            },
            {
              title: "تقرير المجلس الوطني لحقوق الإنسان",
              year: "22 دجنبر 2024",
              desc: "تقرير المجلس الوطني لحقوق الإنسان حول تشجيع التبليغ عن العنف ضد النساء والفتيات ومناهضة الافلات من العقاب عدم الإنصاف من العنف يعدم الإرادة الإنسانية للمرأة",
              link: "https://cndh.ma/ar/node/6011"
            },
            {
              title: "إعلان ومنهاج عمل بيجين",
              year: "سنة 1995",
              desc: "خطة عمل تاريخية لحقوق المرأة والمساواة بين الجنسين",
              link:"https://archive.unescwa.org/sites/www.unescwa.org/files/u1281/bdpfa_a.pdf"
            },
            {
              title: "إعلان وبرنامج عمل فيينا",
              year: "سنة 1993",
              desc: "وثيقة تاريخية حول حقوق الإنسان بما في ذلك حقوق المرأة",
              link:"https://www.ohchr.org/sites/default/files/vienna.pdf"
            },
            {
              title: "الإعلان العالمي لحقوق الإنسان",
              year: "10 ديسمبر 1948",
              desc: "الوثيقة الأساسية لحقوق الإنسان العالمية",
              link:"https://www.un.org/ar/udhrbook/pdf/udhr_booklet_ar_web.pdf"
            },

            {
              title: "الهدف الخامس من أهداف التنمية المستدامة",
              year: "أجندة 2030",
              desc: "تحقيق المساواة بين الجنسين وتمكين كل النساء والفتيات",
              link:"https://www.un.org/sustainabledevelopment/ar/wp-content/uploads/sites/2/2017/01/wim_dgs5.pdf"
            }
          ].map((ref, index) => (
            <div key={index} style={{
              background: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
              borderRadius: '20px',
              padding: '30px',
              border: '1px solid rgba(255, 107, 53, 0.2)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.borderColor = '#ff6b35';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(255, 107, 53, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(255, 107, 53, 0.2)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <h3 style={{
                fontSize: '1.4rem',
                color: '#ff6b35',
                marginBottom: '15px',
                fontWeight: '700'
              }}>
                {ref.title}
              </h3>
              {ref.year && (
                <p style={{
                  fontSize: '1rem',
                  color: '#b0b0b0',
                  lineHeight: '1.7',
                  marginBottom: '10px'
                }}>
                  {ref.year}
                </p>
              )}
              <p style={{
                fontSize: '0.95rem',
                color: '#999',
                lineHeight: '1.6',
                marginBottom: '20px'
              }}>
                {ref.desc}
              </p>
              {ref.link ? (
                <a href={ref.link}
                   target="_blank"
                   rel="noopener noreferrer"
                   style={{
                     display: 'inline-block',
                     padding: '10px 20px',
                     background: '#ff6b35',
                     color: '#ffffff',
                     borderRadius: '8px',
                     textDecoration: 'none',
                     fontSize: '0.95rem',
                     fontWeight: '600',
                     transition: 'all 0.3s ease'
                   }}
                   onMouseEnter={(e) => e.currentTarget.style.background = '#ff8555'}
                   onMouseLeave={(e) => e.currentTarget.style.background = '#ff6b35'}>
                  الاطلاع على الوثيقة
                </a>
              ) : (
                <div style={{
                  padding: '10px 15px',
                  background: 'rgba(255, 107, 53, 0.1)',
                  borderRadius: '8px',
                  fontSize: '0.9rem',
                  color: '#ff6b35',
                  textAlign: 'center'
                }}>
                  متاح على موقع الأمم المتحدة
                </div>
              )}
            </div>
          ))}
        </div>

        <div style={{
          background: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
          padding: '30px',
          borderRadius: '15px',
          borderRight: '4px solid var(--primary-orange)',
          marginTop: '30px',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '1.1rem',
            color: '#e0e0e0',
            lineHeight: '1.8',
            marginBottom: '0'
          }}>
            جميع هذه الوثائق تشكل الإطار القانوني والمرجعي الشامل لحماية حقوق النساء ومكافحة العنف ضدهن على المستويين الوطني والدولي
          </p>
        </div>
      </div>

      <div className="section-separator2"></div>

      {/* Photo Gallery Section */}
      <div className="container" style={{ padding: '60px 0' }}>
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2.5rem',
            color: '#ffffff',
            marginBottom: '15px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '15px'
          }}>
            <Image size={40} color="#ff6b35" />
            عينة إبداعات مناهضة للعنف الرقمي ضد النساء والفتيات
          </h2>

        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '30px',
          marginBottom: '40px'
        }}>
          {photoGallery.map((photo, index) => (
            <div key={photo.id} style={{
              background: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
              borderRadius: '20px',
              overflow: 'hidden',
              border: '1px solid rgba(255, 107, 53, 0.2)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.borderColor = '#ff6b35';
              e.currentTarget.style.boxShadow = '0 15px 40px rgba(255, 107, 53, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(255, 107, 53, 0.2)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <div style={{
                width: '100%',
                height: '280px',
                background: 'linear-gradient(135deg, #3a3a3a 0%, #2a2a2a 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  background: `repeating-linear-gradient(
                    45deg,
                    transparent,
                    transparent 10px,
                    rgba(255, 107, 53, 0.05) 10px,
                    rgba(255, 107, 53, 0.05) 20px
                  )`
                }}></div>
                <img
                     src={photo.image}
                     alt={photo.title}
                     style={{
                       width: '100%',
                       height: '100%',
                       objectFit: 'cover',
                       transition: 'transform 0.3s ease'
                     }}
                     onMouseEnter={(e) => {
                       e.currentTarget.style.transform = 'scale(1.05)';
                     }}
                     onMouseLeave={(e) => {
                       e.currentTarget.style.transform = 'scale(1)';
                     }}
                   />
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '60px',
                  background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)'
                }}></div>
              </div>

            </div>
          ))}
        </div>
      </div>

      <div className="section-separator2"></div>



      {/* Call to Action */}
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <h3 style={{
          fontSize: '2.5rem',
          marginBottom: '25px',
          color: 'var(--white)'
        }}>
        قافلة نحن معا من أجل القضاء على العنف الرقمي
        </h3>
        <p style={{
          fontSize: '1.3rem',
          marginBottom: '30px',
          color: 'var(--text-light)',
          lineHeight: '1.8'
        }}>

        المعرفة بالأرقام والقوانين هي السلاح الأول في مواجهة العنف الرقمي. كل وثيقة هنا هي خطوة نحو مجتمع رقمي آمن للجميع.

        </p>
            <Carousel />
      </div>
    </div>

  );
};

export default Chiffres;
